module.exports = __webpack_public_path__ + "img/1784792583305-Tas Ilung - Lisda 0512.jpg.f3583aff.webp";